/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 13,
    height: 10,
    viewBox: '0 0 13 10',
    data: '<g _fill="#FFF" fill-rule="evenodd"><path pid="0" d="M1.064.445l5.22 4.452.015.016c.129.116.305.116.418 0l.016-.016L11.952.445c.016-.016.032-.016.048-.033A2.61 2.61 0 0010.635 0h-8.27A2.47 2.47 0 001 .412a.12.12 0 01.064.033"/><path pid="1" d="M12.613 1.016a.365.365 0 01-.108.11L7.49 5.39c-.294.253-.65.395-1.02.395-.372 0-.728-.126-1.022-.395L.433 1.126c-.046-.031-.077-.079-.108-.11C.124 1.379 0 1.806 0 2.263v5.21C0 8.864 1.114 10 2.476 10h7.986c1.362 0 2.476-1.137 2.476-2.526v-5.21c0-.459-.124-.885-.325-1.248"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/mail.js